var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManomanowhite = function SvgManomanowhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#manomano_white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.997.538 4.432 5.461c.32.394.405.928.223 1.4l-2.514 6.568c-.18.474-.6.814-1.1.894l-6.946 1.107c-.5.08-1.005-.113-1.325-.506L.336 10a1.418 1.418 0 0 1-.224-1.4l2.515-6.57c.18-.472.6-.812 1.1-.892L10.673.03c.5-.08 1.005.113 1.324.507ZM8.728 7.537l1.573-2.814 2.727.484v5.935l-1.99.673v-4.8L8.94 10.768H7.849L6.432 7.267l-1.438 3.675H2.862l2.39-6.231 1.93-.514 1.546 3.34Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "manomano_white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16.8v16H0z"
  })))));
};
export default SvgManomanowhite;